import React, { useEffect } from "react";
import { MotifSelect, MotifFormField,  MotifOption} from '@ey-xd/motif-react';

type SelectBoxType = {
    options: {label : string, value: string}[]; 
    value: string;
    onChange: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    filter?: boolean | ((x?: any) => void) | undefined;
    searchPlaceholder? : string;
    defaultValue?: string;
    visibleOptions?: number;
    placeholder?: string;
    disabled?: boolean;
    multiple?: boolean;
}

export default function SelectBox ({ options, value, defaultValue, onChange, filter, searchPlaceholder, visibleOptions,placeholder,disabled,multiple}: SelectBoxType) {
    useEffect(() => {
        const btn = document.querySelectorAll('.motif-select-input') as NodeListOf<Element>;
        btn.forEach((element: Element) => {
            (element as HTMLElement).setAttribute('type', 'button');
        });
    },[]);
    const selectedValue = value || defaultValue || '';
    return (
        <> 
            <MotifFormField role="group"> 
                {/*@ts-ignore */}
                <MotifFormField>
                    <MotifSelect
                        ariaLabelledBy="select-label"
                        onChange={onChange}
                        value={selectedValue}
                        filter={filter}
                        searchPlaceholder={searchPlaceholder}
                        visibleOptions={visibleOptions}
                        placeholder={selectedValue === '' || selectedValue === null || selectedValue === undefined ? placeholder : selectedValue }
                        disabled={disabled === true ? true : false}
                        multiple={multiple}
                    >
                        {
                            options.map( (option,index) => (
                                <MotifOption isSelected={option.value === selectedValue} key={`${option.value}-${index}`} value={option.value}>{option.label}</MotifOption>
                            ))
                        }
                    </MotifSelect>
                </MotifFormField> 
            </MotifFormField>
        </>
        
    );
}